import { Component, Input } from "@angular/core";
import { Chip } from "./chip";

@Component({
    selector: "chip-collection",
    templateUrl: "./chipCollection.tmpl.html",
    standalone: false
})
export class ChipCollectionComponent
{
    @Input() readonly chips: ReadonlyArray<Chip>;
}
